import Account from './Account';
import Documents from './Documents';
import Integrations from './Integrations';
import { ModuleDeclaration } from './ModuleDeclaration';
import PromptChains from './PromptChains';
import Seo from './SEO';
import Social from './Social';
import Themes from './Themes';
import Welcome from './Welcome';

const modules: Array<ModuleDeclaration> = [Themes, Documents, Social, Integrations, Account, Seo, PromptChains, Welcome];

export default modules;
